import { render, staticRenderFns } from "./BookCard.vue?vue&type=template&id=1b4a56e2&scoped=true"
import script from "./BookCard.vue?vue&type=script&lang=ts"
export * from "./BookCard.vue?vue&type=script&lang=ts"
import style0 from "./BookCard.vue?vue&type=style&index=0&id=1b4a56e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4a56e2",
  null
  
)

export default component.exports